import {Box, Grid, Typography } from "@mui/material";
import {Stack} from "@mui/material";
import Button from "components/atoms/Button";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import appstoreEn from "assets/app-store--en.svg";
import appstoreAr from "assets/app-store--ar.svg";
import playStoreEn from "assets/google-play--en.svg";
import playstoreAr from "assets/google-play--ar.svg";
import appStoreDarkEn from "assets/app-store-dark--en.svg";
import appStoreDarkAr from "assets/app-store-dark--ar.svg";
import playStoreDarkEn from "assets/google-play-dark--en.svg";
import playStoreDarkAr from "assets/google-play-dark--ar.svg";
import theme from "theme";
import { ArrowForward,ArrowBack } from "@mui/icons-material";
import eventBasicBanner from "assets/services/event-basis-banner.webp";

const HeroSection = () => {
  const { t, i18n } = useTranslation("");
const navigate=useNavigate()
  return (
    <div>
        <Box
          sx={{
            minHeight: "50vh",
            display: "flex",
            backgroundImage: `url(${eventBasicBanner})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            position: "relative",
            overflow: "hidden",
            borderRadius: 5,
            p: 5,
            pt:8,
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "linear-gradient(135deg, rgba(0, 0, 0, 0.4) 0%, rgba(82, 10, 118, 0.3) 100%)",
              zIndex: 1,
            },
          }}
        >
          <Grid container spacing={8} sx={{ position: "relative", zIndex: 2 }}>
            <Grid item xs={12} lg={12}>
              <Box>
                <Typography
                  variant="h1"
                  sx={{
                    fontSize: { xs: "1.5rem", sm: "2.5rem", md: "3.5rem" },
                    fontWeight: 800,
                    mb: 2,
                    color: theme.palette.secondary.light,
                    lineHeight: 1.1,
                    background: "linear-gradient(135deg, #ffffff 0%, #f0f0f0 100%)",
                    backgroundClip: "text",
                  }}
                >
                 {/* <span style={{ color: theme.palette.primary.light}}>{t("Luxury")}</span> */}
                 <span style={{ color: theme.palette.primary.light}}> {t("eventTransportation").split(" ")[0] }</span> {" "}
                  {
                     t("eventTransportation").split(" ").slice(1 , 20).join(" ")
                  }
                  {/* {t("eventTransportation")} */}
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    fontSize: { xs: "0.8rem", md: "1.2rem" },
                    fontWeight: 400,
                    color: theme.palette.secondary.light,
                    mb: 6,
                    lineHeight: 1.6,
                  }}
                >
  
                  {t("heroSectionDetail")}
                </Typography>

                {/* Action Buttons */}
              <Button
              variant="contained"
              size="large"
              color="primary"
              endIcon={ i18n.language=== "en" ? <ArrowForward/>:<ArrowBack/>}
              onClick={()=> navigate("/add-event")}
              sx={{
                "&:hover": {
                  transform: "translateY(-3px)",
                },
                px:2.5,
                py:3,
                fontWeight: 500,
                height: "42px",
                borderRadius: "12px",
                textTransform: "capitalize",
                color:"black",
                fontSize: "1.19rem",
                boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                transition: "all 0.3s ease",
              }}
            >
              {t("getAQuote")}
             </Button>

                <Stack
                direction={"row"}
                gap={2}
                justifyContent={{
                  xs: "center",
                  md: i18n.language === "ar" ? "flex-end" : "start",
                }}
                mt={35}
              >
                <Box borderRadius={"7px"}>
                  <Link
                    to="https://apps.apple.com/us/app/yelo-limousine/6446365805"
                    target="_blank"
                  >
                    {i18n.language === "en" ? (
                      <>
                        <Box
                          component={"img"}
                          display={{ xs: "none", md: "block" }}
                          src={appstoreEn}
                          alt="App Store"
                        />
                        <Box
                          component={"img"}
                          display={{ xs: "block", md: "none" }}
                          src={appStoreDarkEn}
                          alt="App Store"
                        />
                      </>
                    ) : (
                      <>
                        <Box
                          component={"img"}
                          display={{ xs: "none", md: "block" }}
                          src={appstoreAr}
                          alt="App Store"
                        />
                        <Box
                          component={"img"}
                          display={{ xs: "block", md: "none" }}
                          src={appStoreDarkAr}
                          alt="App Store"
                        />
                      </>
                    )}
                  </Link>
                </Box>
                <Box borderRadius={"7px"}>
                  <Link
                    to="https://play.google.com/store/apps/details?id=com.wefaq.limousine"
                    target="_blank"
                  >
                    {i18n.language === "en" ? (
                      <>
                        <Box
                          component={"img"}
                          display={{ xs: "none", md: "block" }}
                          src={playStoreEn}
                          alt="Play Store"
                        />
                        <Box
                          component={"img"}
                          display={{ xs: "block", md: "none" }}
                          src={playStoreDarkEn}
                          alt="Play Store"
                        />
                      </>
                    ) : (
                      <>
                        <Box
                          component={"img"}
                          display={{ xs: "none", md: "block" }}
                          src={playstoreAr}
                          alt="Play Store"
                        />
                        <Box
                          component={"img"}
                          display={{ xs: "block", md: "none" }}
                          src={playStoreDarkAr}
                          alt="Play Store"
                        />
                      </>
                    )}
                  </Link>
                </Box>
              </Stack>
              </Box>
            </Grid>
          </Grid>
        </Box>
       
    </div>
  );
};

export default HeroSection;
